module.exports = __webpack_public_path__ + "media/application/images/feedback-bg-04a3569e273e8f2307be0684e0aa3ab0.png";